const template = (data) => `
    <div class="grid__item">
        <div class="card">
            ${data.name ? `<h3 class="card__heading">${data.name}</h3>` : ''}
            <p>example card response</p>
        </div>
    </div>
`
export default template
